import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXoa } from "./ModalXoa";
import QuanLyThuChiHopDongApi from "service/quanLyThuChiHopDongApi";
export const BtnXoa = ({ item }) => {
  const [show, setShow] = useState(false);
  const [isXoa, setIsXoa] = useState(1);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const CheckXoaThuChi = (ThuChiID) => () => {
    QuanLyThuChiHopDongApi.checkXoaThuChiHopDong(ThuChiID).then((response) => {
      setIsXoa(parseInt(response.data));
      handleShow();
    });


    //handleShow();
  }

  return (
    <>
      <a onClick={CheckXoaThuChi(item.ThuChiID)} href={() => false}>
        <PopoversBootrap
          contentText="Xoá phiếu"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img
                              style={{ marginLeft: "5px" }}
                              src="/app-assets/images/icon-xoa-v2.png"
                            />
        </PopoversBootrap>
      </a>
      {show && (
        <ModalXoa show={show} onHide={handleClose} thuChiId={item.ThuChiID} IndexId={isXoa} />
      )}
    </>
  );
};
